import { render, staticRenderFns } from "./VencimientoLista.vue?vue&type=template&id=47e908c3"
import script from "./VencimientoLista.vue?vue&type=script&lang=js"
export * from "./VencimientoLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports